









import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { loginModule } from '@/store/authentication/login';
import api from '@/infrastructure/api/api';
import {利用者型} from '@/type/user/user';

@Component({})
export default class UserSelector extends Vue {
  @Prop({default: null})
  private value!: string | null;
  @Prop({default: true})
  private nullable!: boolean;

  private 利用者一覧: 利用者型[] = [];
  private disabled: boolean = false;

  public mounted(): void {
    this.initialize();
  }

  @Emit('input')
  private update(event: Event): string | null {
    const target = event.target as HTMLInputElement;
    if (target.value) {
      return target.value as string;
    }
    return null;
  }

  private async initialize(): Promise<void> {
    this.利用者一覧 = await api.利用者一覧を取得する();
    this.disabled = !loginModule.管理者である;
  }
}
